import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Box from "@oriola-origo/core/lib/Box";
import { Checkbox, FormControlLabel } from "@oriola-origo/origo-ui-core";
import { CaseType } from "../../../../constants/caseType";
import { StatefullTextField } from "../../../common";
import FieldTitle from "../fieldTitle/fieldTitle";
import { getValidationErrorMessage } from "../../../../utils/validations/validations";

interface IncompletePackagesDetailsProps {
  disabled?: boolean;
  error?: string;
  itemData: {
    uuid: string;
    incompletePackagesDetails?: string;
    partialPackage?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
  fieldsConfig: {
    amountOfPackages?: object;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateItem: (item: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateItemValidationError?: (uuid: string, error: any) => void;
}

function IncompletePackagesDetails(
  props: Readonly<IncompletePackagesDetailsProps>
) {
  const {
    disabled,
    itemData,
    updateItem,
    fieldsConfig,
    error,
    updateItemValidationError,
  } = props;
  const {
    caseType,
    // @ts-expect-error expected-error
  } = useSelector(state => state.case.case);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  if (
    !fieldsConfig.amountOfPackages ||
    caseType !== CaseType.SUSPECTED_PRODUCT_DEFECT
  ) {
    return null;
  }

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    if (!checked && updateItemValidationError) {
      dispatch(
        updateItemValidationError(itemData.uuid, {
          incompletePackagesDetails: "",
        })
      );
    }
    dispatch(
      updateItem({
        ...itemData,
        partialPackage: checked,
        // Clear the details text when unchecking
        ...(!checked ? { incompletePackagesDetails: "" } : {}),
      })
    );
  };

  const handleChange = (value: string) => {
    if (updateItemValidationError) {
      dispatch(
        updateItemValidationError(itemData.uuid, {
          incompletePackagesDetails: "",
        })
      );
    }
    dispatch(
      updateItem({
        ...itemData,
        incompletePackagesDetails: value,
      })
    );
  };

  return (
    <Box style={{ width: 250 }}>
      <FormControlLabel
        control={
          <Checkbox
            onChange={handleCheckboxChange}
            name="partialPackage"
            checked={itemData?.partialPackage || false}
          />
        }
        disabled={disabled}
        label={t("caseItemFields.partialPackage")}
      />
      {itemData?.partialPackage && (
        <>
          <FieldTitle title={t("caseItemFields.incompletePackagesDetails")} />
          <StatefullTextField
            initialValue={itemData.incompletePackagesDetails || ""}
            variant="outlined"
            margin="dense"
            multiline
            minRows={2}
            disabled={disabled}
            onChange={handleChange}
            onCustomizeValue={null}
            id="incomplete-packages-details"
            placeholder={t(
              "caseItemFields.incompletePackagesDetailsPlaceholder"
            )}
            inputProps={{ maxLength: 256 }}
            error={!!error}
            helperText={getValidationErrorMessage(error, t)}
          />
        </>
      )}
    </Box>
  );
}

export default IncompletePackagesDetails;
